var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
var LanguageContext = createContext(undefined);
export var LanguageProvider = function (_a) {
    var children = _a.children;
    var _b = useState('fr'), language = _b[0], setLanguage = _b[1];
    var _c = useState(false), isMultilingual = _c[0], setIsMultilingual = _c[1];
    return (_jsx(LanguageContext.Provider, __assign({ value: { language: language, setLanguage: setLanguage, isMultilingual: isMultilingual, setIsMultilingual: setIsMultilingual } }, { children: children })));
};
export var useLanguage = function () {
    var context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
